import React, { useEffect } from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
import { withRouterProps } from '../../utils/with-router-props'
import { fetchApiDataIfNeeded } from '../../../actions/api'
// import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { apiResourceEndpoint } from '../../../constants/routes'
import EditableDisplayField from '../../utils/editable-display-field'
import AccountSidebar from '../../shared/account-sidebar'

const mapStateToProps = (state, ownProps) => {
    return {
        account: state.adminAccounts.find(a => a.id === Number(ownProps.params.accountId)),
        accountTypes: state.adminAccountTypes
    }
}

const AdminUsersView = ({ dispatch, params, navigate, account, accountTypes }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'VIEW', params.accountId)))
    }, [dispatch, params.accountId])

    useEffect(() => {
        if (account) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/account-types', 'LIST')))
        }
    }, [dispatch, account])

    const accountTypeOptions = accountTypes.map(at => ({
        label: at.name,
        value: at.id
    }))

    if (!account) {
        return null
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Editing {account.name}</h1>
                        <p>Use the fields below to edit account details.</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sidebar-layout">
                    <div className="sidebar content-box">
                        <AccountSidebar account={account} />
                    </div>
                    <div className="content-box editable">
                        <EditableDisplayField
                            label="Account Name"
                            extraClass="flex-50"
                            display={account.name}
                            endpoint="admin/accounts"
                            dataObj={account}
                            inTable={true}
                            fields={[{
                                field: 'name',
                                type: 'text',
                                required: true
                            }]} />
                        <EditableDisplayField
                            label="Account Type"
                            extraClass="flex-50"
                            display={account._computed.accountTypeName}
                            endpoint="admin/accounts"
                            dataObj={account}
                            inTable={true}
                            fields={[{
                                field: 'accountTypeId',
                                type: 'valueSelect',
                                options: accountTypeOptions,
                                required: true
                            }]} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminUsersView))
